import { SET_TRANSACTION_COUNT } from "../action";
import { txnsForReviewCount } from "./initial-store";

const initialState = txnsForReviewCount;

function txnsForReviewCountReducer(state = initialState, action) {
  switch (action.type) {
    case SET_TRANSACTION_COUNT:
      return action.payload;
    default:
      return state;
  }
}

export default txnsForReviewCountReducer;
